import select2 from 'select2/dist/js/select2.full';
import jQuery from './jquery';

select2(window, jQuery);
